import React from "react";
import Layout from "../components/Layout";
import { Box } from "@mui/material";
import Onboarding from "../components/Onboarding";

const OnboardingRoute = () => {
  return (
    <Layout>
      <Box sx={{ padding: 4, maxWidth: 720, margin: "0 auto" }}>
        <Onboarding />
      </Box>
    </Layout>
  );
};

export default OnboardingRoute;
